import { useCheckPermission as e } from "../queries/state/useCheckPermission.mjs";
import "react";
import { Fragment as t, jsx as n } from "react/jsx-runtime";
//#region src/components/PermissionRestricted.tsx
var r = ({ permission: r, children: i, fallback: a = null }) => {
	let { hasPermission: o, isLoading: s } = e(r);
	return s ? /* @__PURE__ */ n(t, { children: a }) : o ? /* @__PURE__ */ n(t, { children: i }) : null;
};
//#endregion
export { r as PermissionRestricted };
